export default __webpack_public_path__ + "fixing-the-mustache.4863f942.png";